import { routesBuilder } from '@guiker/api-definition'

import { ListingInquiry } from '../../../entity'
import { paths } from '../paths'
import { routes as idNestedRoutes } from './:id'
import { createInquiryPayloadSchema } from './schemas'

const listingInquiry = routesBuilder<ListingInquiry>()({
  basePath: paths.listingInquiry.one.base(),
})

export const routes = {
  ...idNestedRoutes,
  createListingInquiry: listingInquiry.buildPost({
    payloadSchema: createInquiryPayloadSchema,
  }),
}
